import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

export interface PrintReturn {
  doPrint: true;
  printOptions: {
    printReferentHeader: boolean;
  };
}

@Component({
  selector: 'app-modal-print-protocol',
  templateUrl: './modal-print-protocol.component.html',
  styleUrls: [
    './modal-print-protocol.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class ModalPrintProtocolComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public printReferentHeader: boolean;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      printReferentHeader: [this.printReferentHeader]
    });
  }

  public closeModal(doPrint = false): void {
    this.closeEmitter.emit({
      doPrint,
      printOptions: {
        printReferentHeader: this.formGroup.get('printReferentHeader').value
      }
    } as PrintReturn);
  }

}
